import React from "react";
import EditDeviceCheckbox from "./EditDeviceCheckbox";


function ChecklistSection({ device, onDeviceChange, disabled }) {

    return (<>
        <div className="edit-device-option-heading">Notification Types</div>

        <EditDeviceCheckbox label={"Enable Syslog Processing"}
            value={device.enableSyslogProcessing}
            onChange={(value) => onDeviceChange({ enableSyslogProcessing: value })}
            disabled={disabled} />

        <EditDeviceCheckbox label={"Enable Alerting"}
            value={device.enableAlerting}
            onChange={(value) => onDeviceChange({ enableAlerting: value })}
            disabled={disabled} />

        <EditDeviceCheckbox label={"Enable Syslog Notification"}
            value={device.enableSyslogNotification}
            onChange={(value) => onDeviceChange({ enableSyslogNotification: value })}
            disabled={disabled} />

        <EditDeviceCheckbox label={"Enable Email Notification"}
            value={device.enableEmailNotification}
            onChange={(value) => onDeviceChange({ enableEmailNotification: value })}
            disabled={disabled} />

        {/*
        <EditDeviceCheckbox label={"Enable SNMP Notification"}
            value={device.enableSnmpNotification}
            onChange={(value) => onDeviceChange({ enableSnmpNotification: value })}
            disabled={disabled} />
        */}

    </>)


}

export default ChecklistSection;
